import React from "react";
import { portraitEvidence } from "../../data/portraits";
import EvidenceImage from "../../components/investigation/EvidenceImage";
import StickyNote from "../../components/investigation/StickyNote";

const PINS = ["black", "brass", "red"];
const ROTATIONS = [-2.2, 1.4, -0.8, 2.1, -1.6, 0.9, -2.4, 1.8];

export const PortraitsSection = () => (
  <div className="portraits-cluster">
    <ul className="portraits-wall">
      {portraitEvidence.map((photo, index) => (
        <li key={photo.id}>
          <EvidenceImage
            src={photo.src}
            alt={photo.alt}
            variant="portrait"
            pin={photo.match ? "red" : PINS[index % PINS.length]}
            rotate={ROTATIONS[index % ROTATIONS.length]}
            label={`P-${String(index + 1).padStart(2, "0")}`}
            caption={photo.label}
            circled={photo.match}
            className="portraits-wall-photo"
          />
        </li>
      ))}
    </ul>
    <StickyNote color="yellow" pin="red" rotate={3} className="portraits-note">
      <p className="hand">{portraitEvidence.length} sightings, one subject</p>
      <p>last seen at a keyboard. →</p>
    </StickyNote>
  </div>
);

export default PortraitsSection;
